import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { TabsUI } from "~/components/ui/TabsUI";
import type { ProductGalleryWithTabsStoryblok } from "~/generated/sb/blok-types";
import type { BlokData } from "~/srpc/routes/story.router";

export const ProductGalleryWithTabsBlok = ({
	blok,
	data,
	preview,
}: BlokProps<ProductGalleryWithTabsStoryblok, BlokData["productGalleryWithTabs"]>) => {
	return (
		<BlokWrap asChild editable={blok}>
			<TabsUI title={blok.Title} tabsData={data} preview={preview} />
		</BlokWrap>
	);
};
